import script from "./SupersessionProductDropDownBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SupersessionProductDropDownBox.vue?vue&type=script&setup=true&lang=js"

import "./SupersessionProductDropDownBox.vue?vue&type=style&index=0&id=542f0e97&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-542f0e97"]])

export default __exports__